import { setToken, getToken, removeToken } from '@/utils/auth'
import { Message } from 'element-ui'
import { setStore, getStore } from '@/utils/store'
import { loginByUsername, logout, ssoLogin, getUserInfo, refreshToken } from '@/api/user'

const user = {
  state: {
    tenantId: getStore({ name: 'tenantId' }) || '',
    userInfo: getStore({ name: 'userInfo' }) || '',
    token: getToken() || '',
    refresh_token: getStore({ name: 'refresh_token' }) || ''
  },
  actions: {
    // 根据用户名登录
    LoginByUsername({ commit }, form) {
      return new Promise((resolve, reject) => {
        loginByUsername(form)
          .then(res => {
            const data = res.data
            data.tenant_id = data.tenant_id ? data.tenant_id : '000000'
            if (data.error_description) {
              Message({
                message: data.error_description,
                type: 'error'
              })
              reject(new Error('登录失败'))
            } else {
              commit('SET_TOKEN', data.access_token)
              commit('SET_REFRESH_TOKEN', data.refresh_token)
              commit('SET_TENANT_ID', data.tenant_id)
              commit('SET_USER_INFO', JSON.stringify(data))
              resolve()
            }
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // 单点登录
    SsoLogin({ commit }, params) {
      return new Promise((resolve, reject) => {
        ssoLogin(params.token, params.userType)
          .then(res => {
            const data = res.data
            data.tenant_id = data.tenant_id || '000000'
            if (data.error_description) {
              Message({
                message: data.error_description,
                type: 'error'
              })
              reject(new Error('登录失败'))
            } else {
              commit('SET_TOKEN', data.access_token)
              commit('SET_REFRESH_TOKEN', data.refresh_token)
              commit('SET_TENANT_ID', data.tenant_id)
            }
          })
          .then(() => {
            // 获取用户中心信息
            getUserInfo()
              .then(res => {
                commit('SET_USER_INFO', res.data.data)
                resolve()
              })
              .catch(() => {
                Message({
                  message: '获取用户信息失败',
                  type: 'error'
                })
                reject(new Error('获取用户信息失败'))
              })
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // 刷新token
    RefreshToken({ state, commit }) {
      if (!state.refresh_token) return
      refreshToken(state.refresh_token).then(res => {
        commit('SET_TOKEN', res.data.access_token)
        commit('SET_REFRESH_TOKEN', res.data.refresh_token)
      })
    },
    // 登出
    LogOut({ commit }) {
      return new Promise((resolve, reject) => {
        logout()
          .then(() => {
            commit('SET_TOKEN', '')
            commit('SET_REFRESH_TOKEN', '')
            commit('SET_USER_INFO', '')
            commit('SET_TENANT_ID', '')
            removeToken()
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // 注销session
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        commit('SET_REFRESH_TOKEN', '')
        commit('SET_USER_INFO', '')
        commit('SET_TENANT_ID', '')
        removeToken()
        resolve()
      })
    }
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      setToken(token)
      state.token = token
    },
    SET_REFRESH_TOKEN: (state, refresh_token) => {
      state.refresh_token = refresh_token
      setStore({ name: 'refresh_token', content: state.refresh_token })
    },
    SET_TENANT_ID: (state, tenantId) => {
      state.tenantId = tenantId
      setStore({ name: 'tenantId', content: state.tenantId })
    },
    SET_USER_INFO: (state, userInfo) => {
      state.userInfo = userInfo
      setStore({ name: 'userInfo', content: state.userInfo })
    }
  }
}

export default user
